<fa-icon [icon]="$any(faCircleInfo)"
         [tooltip]="tooltipText"
         placement="right" />
